<template>
  <table class="table text-left">
    <tbody>
      <tr v-if="rowData.management_roles">
        <td>
          <span v-for="(role, roleIndex) in rowData.management_roles" :key="roleIndex">
            <el-tag type="info" style="height: auto; width: 98%">
              {{ $t('common_words.name') }}: {{ role.name }}<br />
              {{ $t('common_words.associated_users2') }}:<br />
              <span v-for="(user, userIndex) in getUsersArray(role.users).slice(0, 3)" :key="userIndex">
                - {{ user.name }}<br />
              </span>
            </el-tag>
          </span>
        </td>
      </tr>
      <el-tag v-else type="warning" effect="dark" class="mt-2">
        {{ $t('common_words.no_assignment') }}
      </el-tag>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'management-roles-dialog',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // Convertir el objeto de usuarios en un array para poder utilizar v-for
    getUsersArray(usersObject) {
      return Object.values(usersObject);
    },
  },
};
</script>
